import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import AmexHowItWorksItem from './AmexHowItWorksItem';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import './AmexHowItWorks.scss';

const MAX_ITEMS = 4;
const MIN_ITEMS = 3;

const AmexHowItWorks = (
  {
    iconPathPrefix,
    howItWorksConfig: {
      title,
      content = [],
      ribbon = {},
    },
    cardName,
    isResyCredit2026Enabled,
    matchMedia,
  }
) => {
  if (!title || content.length === 0) return null;
  const requiredKeys = ['title', 'icon'];
  const programContent = content.slice()
    .filter((item) => requiredKeys.every((i) => Object.prototype.hasOwnProperty.call(item, i) && item[i]))
    .slice(0, MAX_ITEMS);

  if (programContent.length === 0 || programContent.length < MIN_ITEMS) return null;

  const sanitizedTitle = sanitizeString(title);

  const getItemText = (item) => {
    let itemText = item.text;
    if (cardName && item.textArr) {
      itemText = item.textArr?.find((textObj) => textObj.type === cardName)?.text;
    }
    return itemText;
  };

  return (
    <section className="AmexHowItWorks">
      <div className="container">
        <h2
          className={cx('AmexHowItWorks__title',
            { titleNonRefresh: !isResyCredit2026Enabled && !matchMedia?.md })}
          dangerouslySetInnerHTML={{
            __html: sanitizedTitle,
          }}
        />
        <div className="AmexHowItWorks__body">
          <ul className={`AmexHowItWorks__list list-${programContent.length}`}>
            {programContent.map((item) => (
              <AmexHowItWorksItem
                key={item.title}
                icon={item.icon}
                iconPathPrefix={iconPathPrefix}
                text={getItemText(item)}
                title={item.title}
              />
            ))}
          </ul>
        </div>
        {ribbon?.text && (
          <div
            className="AmexHowItWorks__ribbon"
            style={{ backgroundColor: ribbon?.bg_color }}
          >
            <p
              className="AmexHowItWorks__ribbon--text"
              style={{ color: ribbon?.color }}
              dangerouslySetInnerHTML={{
                __html: sanitizeString(ribbon.text),
              }}
            />
          </div>
        )}
      </div>
    </section>
  );
};

AmexHowItWorks.propTypes = {
  iconPathPrefix: PropTypes.string.isRequired,
  howItWorksConfig: PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    ribbon: PropTypes.shape({
      text: PropTypes.string,
      color: PropTypes.string,
      bg_color: PropTypes.string,
    }),
  }),
  cardName: PropTypes.string,
  isResyCredit2026Enabled: PropTypes.bool,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }),
};

AmexHowItWorks.defaultProps = {
  cardName: null,
  howItWorksConfig: {
    ribbon: {},
  },
  isResyCredit2026Enabled: false,
  matchMedia: null,
};

export default AmexHowItWorks;
